import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  BulkPaymentState,
  BulkPaymentUploadRequest,
  BulkPaymentUploadResponse,
} from 'redux/types/Allocation.types';

export const bulkPaymentInitialState: BulkPaymentState = {
  loading: false,
  error: null,
  success: false,
  data: null,
};

const bulkPaymentSlice = createSlice({
  name: 'bulkPayment',
  initialState: bulkPaymentInitialState,
  reducers: {
    bulkPaymentUploadReq(
      state,
      action: PayloadAction<BulkPaymentUploadRequest>
    ) {
      state.loading = true;
      state.error = null;
      state.success = false;
      state.data = null;
    },
    bulkPaymentUploadSuccess(
      state,
      action: PayloadAction<BulkPaymentUploadResponse>
    ) {
      state.loading = false;
      state.success = true;
      state.data = action.payload;
    },
    bulkPaymentUploadFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetBulkPaymentState: () => bulkPaymentInitialState,
  },
});

export const {
  bulkPaymentUploadReq,
  bulkPaymentUploadSuccess,
  bulkPaymentUploadFailure,
  resetBulkPaymentState,
} = bulkPaymentSlice.actions;

export default bulkPaymentSlice.reducer;
